<div style="display: flex">
  <img src="../../../assets/img/app_logo.svg" style="margin-left: auto; margin-right: auto;" />
</div>

<form id="login-form" nzLayout="vertical" nz-form class="login--form" [formGroup]="form" (keydown.enter)="onSubmit()">
  <nz-form-item [nzGutter]="[8, 8]">
    <nz-form-label> Имя пользователя </nz-form-label>
    <nz-form-control>
      <rais-text-input formControlName="login" data-testid="login-input"></rais-text-input>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item [nzGutter]="[8, 8]">
    <nz-form-label> Пароль </nz-form-label>
    <nz-form-control>
      <rais-input-wrapper [extraSuffixTemplate]="passwordToggleTemplate">
        <input [type]="showPassword() ? 'text' : 'password'" nz-input formControlName="password" data-testid="password-input"/>
      </rais-input-wrapper>
    </nz-form-control>
  </nz-form-item>
  <ng-template #passwordToggleTemplate>
    <button
      type="button"
      tabindex="-1"
      class="password-visibility-toggle"
      nz-tooltip
      [nzTooltipTitle]="showPassword() ? 'Скрыть пароль' : 'Показать пароль'"
      (click)="togglePasswordVisibility()"
    >
      <span nz-icon [nzType]="showPassword() ? 'eye' : 'eye-invisible'"></span>
    </button>
  </ng-template>
  @if (supportCenterVisible()) {
    <a
      href="javascript:void(0)"
      class="login--support-center-link"
      (click)="openSupportCenter()"
      data-testid="login-support-center-link"
    >
      Центр поддержки
    </a>
  }
</form>
<div class="modal-footer" *nzModalFooter>
  <button nz-button class="btn--flat" nzType="primary" [nzLoading]="isLoggingIn()" [disabled]="form.invalid" (click)="onSubmit()" data-testid="login-btn">
    Войти
  </button>
</div>

